import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
  checkboxContainer: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'flex-end'
  },
  radioLabel: {
    textAlign: 'left',
    marginBottom: '8px'
  },
  radioGroup: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start'
  }
});

export default makeStyles(styles);
